import React, {useEffect, useRef, useState} from 'react'
import {Container, Row, Col, Form, Collapse, Pagination} from 'react-bootstrap'
import FullWidthCard from './ResourcesFullWidthCard'
import clsx from 'clsx'
import {toast} from 'react-toastify'
import {getResourcesData} from '../core/_requests'
import {useIntl} from 'react-intl'
import {useAuth} from '../../auth'
import {Link} from 'react-router-dom'
import FilterIcon from '../../../../media/resources/icons/ic-filter.svg'
import FilterIconFunnel from '../../../../media/resources/icons/filterIcon.svg'
import DropdownIcon from '../../../../media/shared-access/ic-dropdown.svg'
import Skeleton from 'react-loading-skeleton'

import '../styles/document.scss'
import {NoDataPage} from './NoDataPage'
interface ResourceOverviewProps {
  type: string
}

export const ResourceDocuments: React.FC<ResourceOverviewProps> = ({type}) => {
  const [open, setOpen] = useState(true)
  const [showCategories, setShowCategories] = useState(false)

  const categories = [
    {label: 'All', value: 'All'},
    {label: 'NDA', value: 'NDA'},
    {label: 'Business', value: 'Business'},
    {label: 'Productivity', value: 'Productivity'},
    {label: 'Finance', value: 'Finance'},
    {label: 'Legal', value: 'Legal'},
    {label: 'Start Ups', value: 'Start Ups'},
    {label: 'Agreements', value: 'Agreements'},
  ]

  const [AllResourcesData, setAllResourcesData] = useState<any[]>([])
  const {formatMessage} = useIntl()
  const {companyId} = useAuth()
  const [loading, setLoading] = useState<boolean>(true)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [documentPerPage, setDocumentPerPage] = useState<number>(10)
  const [search, setSearch] = useState<string>('')
  const [category, setCategory] = useState<string>(categories.map((cat) => cat.value).join(', '))
  const [sortBy, setSortBy] = useState<string>('')
  const [sortOrder, setSortOrder] = useState<string>('ASC')
  const [count, setCount] = useState<number>(0)
  const [pageNumbers, setPageNumbers] = useState<number[]>([])
  const [selectedCategories, setSelectedCategories] = useState<string[]>(
    categories.map((cat) => cat.value)
  )
  const getAllResources = async () => {
    try {
      // setLoading(true)
      const {
        data: {success, data, errors},
      } = await getResourcesData(
        companyId!,
        currentPage,
        documentPerPage,
        search,
        category,
        sortBy,
        sortOrder
      )
      if (success) {
        setCount(data.totalRecords)
        setAllResourcesData(data.resources)
      } else {
        errors?.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.error('Error fetching resources:', err)
      toast.error(formatMessage({id: 'Failed to fetch resources'}))
    } finally {
      setLoading(false)
    }
  }

  const dropdownRef = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(false)
  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleDocumentsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setDocumentPerPage(Number(event.target.value))
    setCurrentPage(1)
  }

  useEffect(() => {
    if (type === 'resources') {
      getAllResources()
    }
  }, [type, currentPage, documentPerPage, category, sortBy, sortOrder]) // eslint-disable-line

  useEffect(() => {
    const calculatePageNumbers = () => {
      const pages = []
      for (let i = 1; i <= Math.ceil(count / documentPerPage); i++) {
        pages.push(i)
      }
      setPageNumbers(pages)
    }

    calculatePageNumbers()
  }, [count, documentPerPage])

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedCategory = event.target.value
    let updatedCategories = [...selectedCategories]

    if (selectedCategory === 'All') {
      if (event.target.checked) {
        updatedCategories = categories.map((cat) => cat.value)
      } else {
        updatedCategories = ['category']
      }
    } else {
      if (event.target.checked) {
        updatedCategories.push(selectedCategory)
      } else {
        updatedCategories = updatedCategories.filter((cat) => cat !== selectedCategory)
      }
    }

    setSelectedCategories(updatedCategories)
    setCategory(updatedCategories.join(', '))
  }

  useEffect(() => {
    if (
      selectedCategories.length === categories.length - 1 &&
      !selectedCategories.includes('All')
    ) {
      setSelectedCategories([...selectedCategories, 'All'])
    } else if (
      selectedCategories.length !== categories.length &&
      selectedCategories.includes('All')
    ) {
      setSelectedCategories(selectedCategories.filter((cat) => cat !== 'All'))
    }
    setCategory(selectedCategories.join(', '))
  }, [selectedCategories]) // eslint-disable-line

  const handleSortOrderChange = (order: string) => {
    setSortBy('name')
    setSortOrder(order)
  }

  useEffect(() => {
    let handler: any
    if (search.length >= 3 || !search) {
      setLoading(true)
      handler = setTimeout(() => {
        getAllResources()
      }, 200)
    }

    return () => {
      clearTimeout(handler)
    }
  }, [search]) // eslint-disable-line

  return (
    <>
      <div className='d-flex justify-content-between align-items-center my-4 gap-8'>
        <button
          className='d-flex align-items-center btn bg-white gap-2 p-4'
          onClick={() => setShowCategories(!showCategories)}
        >
          <img src={FilterIconFunnel} alt='' />
          <span className='d-none d-sm-block'>{formatMessage({id: 'Filters'})}</span>
        </button>

        <div className='d-flex align-items-center gap-2'>
          <input
            type='text'
            className='bg-body form-control ps-4 rounded-2 font-size-13 font-weight-400'
            name='search'
            placeholder={formatMessage({id: 'Search Resources'})}
            data-kt-search-element='input'
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <div className='card-toolbar' style={{position: 'relative'}} ref={dropdownRef}>
            <Link
              to='#'
              className='btn bg-white rounded-2 p-3'
              onClick={toggleDropdown}
              aria-expanded={isOpen}
            >
              <img src={FilterIcon} alt='Filter Icon' />
            </Link>
            {isOpen && (
              <div
                className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 bg-white shadow w-200px fw-semibold fs-7 py-2'
                style={{
                  position: 'absolute',
                  top: '110%',
                  right: 0,
                  zIndex: 1000,
                  display: isOpen ? 'block' : 'none',
                }}
              >
                <div className='menu-item px-2'>
                  <Link
                    to='#'
                    className={`menu-link px-2 ${sortOrder === 'ASC' ? 'text-primary' : ''}`}
                    onClick={() => handleSortOrderChange('ASC')}
                  >
                    {formatMessage({id: 'Alphabetic (Ascending)'})}
                  </Link>
                </div>
                <div className='menu-item px-2'>
                  <Link
                    to='#'
                    className={`menu-link px-2 ${sortOrder === 'DESC' ? 'text-primary' : ''}`}
                    onClick={() => handleSortOrderChange('DESC')}
                  >
                    {formatMessage({id: 'Alphabetic (Descending)'})}
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Container fluid>
        <Row>
          {showCategories && (
            <Col xs={12} md={3} className='bg-white px-0 rounded-2 h-100'>
              <div
                onClick={() => setOpen(!open)}
                aria-controls='category-collapse'
                aria-expanded={open}
                style={{cursor: 'pointer'}}
              >
                <div className='d-flex justify-content-between align-items-center px-6 py-6'>
                  <h2 className='font-size-14 text-secondry'>
                    {formatMessage({id: 'Categories'})}
                  </h2>
                  <img src={DropdownIcon} alt='' />
                </div>
              </div>
              <Collapse in={open}>
                <div id='category-collapse' className='px-6 h-100'>
                  <Form>
                    {categories.map((cat) => (
                      <Form.Check
                        key={cat.value}
                        type='checkbox'
                        label={formatMessage({id: cat.label})}
                        className='mb-4'
                        style={{color: '#383940'}}
                        value={cat.value}
                        checked={selectedCategories.includes(cat.value)}
                        onChange={handleCheckboxChange}
                      />
                    ))}
                  </Form>
                </div>
              </Collapse>
            </Col>
          )}
          <Col
            xs={12}
            md={showCategories ? 9 : 12}
            className={clsx('px-0 resource-section-v2', {
              'ps-4': showCategories,
              'ps-0': !showCategories,
            })}
          >
            {loading ? (
              Array(9)
                .fill(null)
                .map((_, index) => (
                  <div className='mb-4 rounded-2' key={index}>
                    <Skeleton
                      height={225}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                ))
            ) : (
              <>
                {loading ? (
                  <Skeleton
                    height={225}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                ) : AllResourcesData.length === 0 ? (
                  <NoDataPage />
                ) : (
                  <div className='resources-list'>
                    {AllResourcesData.map((res, index) => {
                      return (
                        <FullWidthCard
                          key={index}
                          id={res.resourceId}
                          title={res.name}
                          type={type}
                          category={res.category}
                          benefits={res.benefits}
                          image={res.previewImage[0]}
                          showCategories={showCategories}
                          downloaded={res.isDownloaded}
                        />
                      )
                    })}
                  </div>
                )}
              </>
            )}

            {/* Pagination Section */}
            <div
              className={clsx('w-100 d-flex justify-content-between align-items-center px-0 mt-8', {
                'd-none': AllResourcesData.length === 0,
              })}
            >
              <div className='d-flex gap-2 w-100 align-items-center'>
                <Form.Select
                  aria-label='Default select example'
                  className='px-4 py-3 w-80px'
                  value={documentPerPage}
                  onChange={handleDocumentsPerPageChange}
                >
                  <option value='10'>{formatMessage({id: '10'})}</option>
                  <option value='20'>{formatMessage({id: '20'})}</option>
                  <option value='50'>{formatMessage({id: '50'})}</option>
                  <option value='100'>{formatMessage({id: '100'})}</option>
                </Form.Select>
                <span className='font-size-13'>
                  {`Showing ${(currentPage - 1) * documentPerPage + 1} to ${Math.min(
                    (currentPage - 1) * documentPerPage + 1 + documentPerPage - 1,
                    count
                  )} of ${count} records`}
                </span>
              </div>
              <Pagination className='w-100 d-flex flex-end'>
                <Pagination.First
                  key='first'
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(1)}
                />
                <Pagination.Prev
                  key='prev'
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                />
                {pageNumbers.map((number) => (
                  <Pagination.Item
                    key={number}
                    active={number === currentPage}
                    onClick={() => setCurrentPage(number)}
                  >
                    {number}
                  </Pagination.Item>
                ))}
                {pageNumbers.length > 6 && (
                  <>
                    {currentPage < pageNumbers.length - 3 && <Pagination.Ellipsis />}
                    {currentPage >= pageNumbers.length - 3 && (
                      <Pagination.Item>{pageNumbers.length}</Pagination.Item>
                    )}
                  </>
                )}
                <Pagination.Next
                  key='next'
                  disabled={currentPage === pageNumbers.length}
                  onClick={() => setCurrentPage((p) => p + 1)}
                />
                <Pagination.Last
                  key='last'
                  disabled={currentPage === pageNumbers.length}
                  onClick={() => setCurrentPage(pageNumbers[pageNumbers.length - 1])}
                />
              </Pagination>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}
